import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { Role } from 'utils/userPermissions';

import { UserNoPassword } from 'types';

const transformUsersList = (data: UserNoPassword[], currentUserId: number) =>
  data.filter(
    (user) => user.role !== Role.SUPER_USER && user.id !== currentUserId
  );

export const getUsers = async (): Promise<UserNoPassword[]> => {
  const { data } = await axios.get(`/api/users`);
  return data as UserNoPassword[];
};

type QueryFnType = typeof getUsers;

type UseUsersOptions = {
  currentUserId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useUsersWithoutSelfOrSuperUser = ({
  currentUserId,
  config,
}: UseUsersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['users'],
    queryFn: getUsers,
    select: (data: UserNoPassword[]) => transformUsersList(data, currentUserId),
    ...config,
  });
};
